<div *ngIf="showBanner" class="offline-banner">
  <div class="banner-content">
    <div class="banner-message">
      <i class="fa fa-exclamation-triangle"></i>

      <span>
        User has been updated. If you are on call your status will be reserved as Break.
        <ng-container *ngIf="showButton">
          Please click update flecx button to see the latest changes.
        </ng-container>
      </span>
    </div>

    <button *ngIf="showButton" class="retry-btn" (click)="refresh()">
      <i class="fas fa-redo-alt"></i>
      Update FleCX
    </button>
  </div>
</div>